require('./assets/javascripts/aws-sdk-2.117.0.min.js');